// Shared
import ECodificacao from '@/shared/enums/ECodificacao';

// Stores
import type { TMenuSibebar } from '@/stores/TemaStore';

// Public
import jsonMenus from '../../../assets/data/menus_dashboards.json';

// Routers
import { cTEMA_VENDAS_ROUTES } from '@/router/temas/rotasTemaVendas';

const menusTemaVendas = jsonMenus.temaVendas;

const cMENUS_TEMA_VENDAS: TMenuSibebar[] = [
  {
    codificacao: ECodificacao.TemaVendas,
    id: menusTemaVendas.children.pedidos.id,
    nameRoute: cTEMA_VENDAS_ROUTES.Pedidos.name,
    icone: menusTemaVendas.children.pedidos.icone,
    titulo: menusTemaVendas.children.pedidos.titulo,
    corIcone: menusTemaVendas.children.pedidos.corIcone,
    children: [
      {
        codificacao: ECodificacao.TemaVendas,
        id: menusTemaVendas.children.pedidos.children.visaoGeral.id,
        nameRoute: cTEMA_VENDAS_ROUTES.Pedidos.VisaoGeral.name,
        icone: menusTemaVendas.children.pedidos.children.visaoGeral.icone,
        titulo: menusTemaVendas.children.pedidos.children.visaoGeral.titulo,
        corIcone: menusTemaVendas.children.pedidos.children.visaoGeral.corIcone,
      },

      {
        codificacao: ECodificacao.TemaVendas,
        id: menusTemaVendas.children.pedidos.children.evolucao.id,
        nameRoute: cTEMA_VENDAS_ROUTES.Pedidos.Evolucao.name,
        icone: menusTemaVendas.children.pedidos.children.evolucao.icone,
        titulo: menusTemaVendas.children.pedidos.children.evolucao.titulo,
      },

      {
        codificacao: ECodificacao.TemaVendas,
        id: menusTemaVendas.children.pedidos.children.analiseGeografica.id,
        nameRoute: cTEMA_VENDAS_ROUTES.Pedidos.AnaliseGeografica.name,
        icone: menusTemaVendas.children.pedidos.children.analiseGeografica.icone,
        titulo: menusTemaVendas.children.pedidos.children.analiseGeografica.titulo,
        corIcone: menusTemaVendas.children.pedidos.children.analiseGeografica.corIcone,
      },

      {
        codificacao: ECodificacao.TemaVendas,
        id: menusTemaVendas.children.pedidos.children.carteiraDeClientes.id,
        nameRoute: cTEMA_VENDAS_ROUTES.Pedidos.CarteiraDeClientes.name,
        icone: menusTemaVendas.children.pedidos.children.carteiraDeClientes.icone,
        titulo: menusTemaVendas.children.pedidos.children.carteiraDeClientes.titulo,
        corIcone: menusTemaVendas.children.pedidos.children.carteiraDeClientes.corIcone,
      },

      {
        codificacao: ECodificacao.TemaVendas,
        id: menusTemaVendas.children.pedidos.children.metaVendas.id,
        nameRoute: cTEMA_VENDAS_ROUTES.Pedidos.MetaVendas.name,
        icone: menusTemaVendas.children.pedidos.children.metaVendas.icone,
        titulo: menusTemaVendas.children.pedidos.children.metaVendas.titulo,
        corIcone: menusTemaVendas.children.pedidos.children.metaVendas.corIcone,
        children: [
          {
            codificacao: ECodificacao.TemaVendas,
            nameRoute: cTEMA_VENDAS_ROUTES.Pedidos.MetaVendas.Especifico.MetaPorSupervisor.name,
            id: menusTemaVendas.children.pedidos.children.metaVendas.children.metaEspecificaPorSupervisor.id,
            icone: menusTemaVendas.children.pedidos.children.metaVendas.children.metaEspecificaPorSupervisor.icone,
            titulo: menusTemaVendas.children.pedidos.children.metaVendas.children.metaEspecificaPorSupervisor.titulo,
            corIcone:
              menusTemaVendas.children.pedidos.children.metaVendas.children.metaEspecificaPorSupervisor.corIcone,
          },

          {
            codificacao: ECodificacao.TemaVendas,
            nameRoute: cTEMA_VENDAS_ROUTES.Pedidos.MetaVendas.Especifico.MetaPorConsultor.name,
            id: menusTemaVendas.children.pedidos.children.metaVendas.children.metaEspecificaPorConsultor.id,
            icone: menusTemaVendas.children.pedidos.children.metaVendas.children.metaEspecificaPorConsultor.icone,
            titulo: menusTemaVendas.children.pedidos.children.metaVendas.children.metaEspecificaPorConsultor.titulo,
            corIcone: menusTemaVendas.children.pedidos.children.metaVendas.children.metaEspecificaPorConsultor.corIcone,
          },

          {
            codificacao: ECodificacao.TemaVendas,
            nameRoute: cTEMA_VENDAS_ROUTES.Pedidos.MetaVendas.Geral.MetaPorSupervisor.name,
            id: menusTemaVendas.children.pedidos.children.metaVendas.children.metaGeralPorSupervisor.id,
            icone: menusTemaVendas.children.pedidos.children.metaVendas.children.metaGeralPorSupervisor.icone,
            titulo: menusTemaVendas.children.pedidos.children.metaVendas.children.metaGeralPorSupervisor.titulo,
            corIcone: menusTemaVendas.children.pedidos.children.metaVendas.children.metaGeralPorSupervisor.corIcone,
          },

          {
            codificacao: ECodificacao.TemaVendas,
            nameRoute: cTEMA_VENDAS_ROUTES.Pedidos.MetaVendas.Geral.MetaPorConsultor.name,
            id: menusTemaVendas.children.pedidos.children.metaVendas.children.metaGeralPorConsultor.id,
            icone: menusTemaVendas.children.pedidos.children.metaVendas.children.metaGeralPorConsultor.icone,
            titulo: menusTemaVendas.children.pedidos.children.metaVendas.children.metaGeralPorConsultor.titulo,
            corIcone: menusTemaVendas.children.pedidos.children.metaVendas.children.metaGeralPorConsultor.corIcone,
          },
        ],
      },

      {
        codificacao: ECodificacao.TemaVendas,
        id: menusTemaVendas.children.pedidos.children.acompanhamento.id,
        nameRoute: cTEMA_VENDAS_ROUTES.Pedidos.Acompanhamento.name,
        icone: menusTemaVendas.children.pedidos.children.acompanhamento.icone,
        titulo: menusTemaVendas.children.pedidos.children.acompanhamento.titulo,
        corIcone: menusTemaVendas.children.pedidos.children.acompanhamento.corIcone,
        children: [
          /*
          {
            codificacao: ECodificacao.TemaVendas,
            nameRoute: cTEMA_VENDAS_ROUTES.Pedidos.Acompanhamento.Diario.name,
            id: menusTemaVendas.children.pedidos.acompanhamento.children.diario.id,
            icone: menusTemaVendas.children.pedidos.acompanhamento.children.diario.icone,
            titulo: menusTemaVendas.children.pedidos.acompanhamento.children.diario.titulo,
            corIcone: menusTemaVendas.children.pedidos.acompanhamento.children.diario.corIcone,
          },
          {
            codificacao: ECodificacao.TemaVendas,
            nameRoute: cTEMA_VENDAS_ROUTES.Pedidos.Acompanhamento.Semanal.name,
            id: menusTemaVendas.children.pedidos.acompanhamento.children.semanal.id,
            icone: menusTemaVendas.children.pedidos.acompanhamento.children.semanal.icone,
            titulo: menusTemaVendas.children.pedidos.acompanhamento.children.semanal.titulo,
            corIcone: menusTemaVendas.children.pedidos.acompanhamento.children.semanal.corIcone,
          },
          */
          {
            codificacao: ECodificacao.TemaVendas,
            nameRoute: cTEMA_VENDAS_ROUTES.Pedidos.Acompanhamento.Quinzenal.name,
            id: menusTemaVendas.children.pedidos.children.acompanhamento.children.quinzenal.id,
            icone: menusTemaVendas.children.pedidos.children.acompanhamento.children.quinzenal.icone,
            titulo: menusTemaVendas.children.pedidos.children.acompanhamento.children.quinzenal.titulo,
            corIcone: menusTemaVendas.children.pedidos.children.acompanhamento.children.quinzenal.corIcone,
          },

          {
            codificacao: ECodificacao.TemaVendas,
            nameRoute: cTEMA_VENDAS_ROUTES.Pedidos.Acompanhamento.Mensal.name,
            id: menusTemaVendas.children.pedidos.children.acompanhamento.children.mensal.id,
            icone: menusTemaVendas.children.pedidos.children.acompanhamento.children.mensal.icone,
            titulo: menusTemaVendas.children.pedidos.children.acompanhamento.children.mensal.titulo,
            corIcone: menusTemaVendas.children.pedidos.children.acompanhamento.children.mensal.corIcone,
          },
          {
            codificacao: ECodificacao.TemaVendas,
            nameRoute: cTEMA_VENDAS_ROUTES.Pedidos.Acompanhamento.Trimestral.name,
            id: menusTemaVendas.children.pedidos.children.acompanhamento.children.trimestral.id,
            icone: menusTemaVendas.children.pedidos.children.acompanhamento.children.trimestral.icone,
            titulo: menusTemaVendas.children.pedidos.children.acompanhamento.children.trimestral.titulo,
            corIcone: menusTemaVendas.children.pedidos.children.acompanhamento.children.trimestral.corIcone,
          },
          {
            codificacao: ECodificacao.TemaVendas,
            nameRoute: cTEMA_VENDAS_ROUTES.Pedidos.Acompanhamento.Semestral.name,
            id: menusTemaVendas.children.pedidos.children.acompanhamento.children.semestral.id,
            icone: menusTemaVendas.children.pedidos.children.acompanhamento.children.semestral.icone,
            titulo: menusTemaVendas.children.pedidos.children.acompanhamento.children.semestral.titulo,
            corIcone: menusTemaVendas.children.pedidos.children.acompanhamento.children.semestral.corIcone,
          },
          {
            codificacao: ECodificacao.TemaVendas,
            nameRoute: cTEMA_VENDAS_ROUTES.Pedidos.Acompanhamento.Anual.name,
            id: menusTemaVendas.children.pedidos.children.acompanhamento.children.anual.id,
            icone: menusTemaVendas.children.pedidos.children.acompanhamento.children.anual.icone,
            titulo: menusTemaVendas.children.pedidos.children.acompanhamento.children.anual.titulo,
            corIcone: menusTemaVendas.children.pedidos.children.acompanhamento.children.anual.corIcone,
          },
        ],
      },

      {
        codificacao: ECodificacao.TemaVendas,
        id: menusTemaVendas.children.pedidos.children.ranking.id,
        nameRoute: cTEMA_VENDAS_ROUTES.Pedidos.Ranking.name,
        icone: menusTemaVendas.children.pedidos.children.ranking.icone,
        titulo: menusTemaVendas.children.pedidos.children.ranking.titulo,
        corIcone: menusTemaVendas.children.pedidos.children.ranking.corIcone,
        children: [
          {
            codificacao: ECodificacao.TemaVendas,
            nameRoute: cTEMA_VENDAS_ROUTES.Pedidos.Ranking.Geral.name,
            id: menusTemaVendas.children.pedidos.children.ranking.children.geral.id,
            icone: menusTemaVendas.children.pedidos.children.ranking.children.geral.icone,
            titulo: menusTemaVendas.children.pedidos.children.ranking.children.geral.titulo,
            corIcone: menusTemaVendas.children.pedidos.children.ranking.children.geral.corIcone,
          },

          {
            codificacao: ECodificacao.TemaVendas,
            nameRoute: cTEMA_VENDAS_ROUTES.Pedidos.Ranking.Itens.name,
            id: menusTemaVendas.children.pedidos.children.ranking.children.itens.id,
            icone: menusTemaVendas.children.pedidos.children.ranking.children.itens.icone,
            titulo: menusTemaVendas.children.pedidos.children.ranking.children.itens.titulo,
            corIcone: menusTemaVendas.children.pedidos.children.ranking.children.itens.corIcone,
          },
        ],
      },

      {
        codificacao: ECodificacao.TemaVendas,
        id: menusTemaVendas.children.pedidos.children.faturadosDevolvidosCancelados.id,
        nameRoute: cTEMA_VENDAS_ROUTES.Pedidos.FaturadosDevolvidosCancelados.name,
        icone: menusTemaVendas.children.pedidos.children.faturadosDevolvidosCancelados.icone,
        titulo: menusTemaVendas.children.pedidos.children.faturadosDevolvidosCancelados.titulo,
        corIcone: menusTemaVendas.children.pedidos.children.faturadosDevolvidosCancelados.corIcone,
      },

      {
        codificacao: ECodificacao.TemaVendas,
        id: menusTemaVendas.children.pedidos.children.curvaABC.id,
        nameRoute: cTEMA_VENDAS_ROUTES.Pedidos.CurvaABC.name,
        icone: menusTemaVendas.children.pedidos.children.curvaABC.icone,
        titulo: menusTemaVendas.children.pedidos.children.curvaABC.titulo,
        corIcone: menusTemaVendas.children.pedidos.children.curvaABC.corIcone,
      },
    ],
  },

  {
    codificacao: ECodificacao.TemaVendas,
    id: menusTemaVendas.children.assistencias.id,
    nameRoute: cTEMA_VENDAS_ROUTES.Assistencias.name,
    icone: menusTemaVendas.children.assistencias.icone,
    titulo: menusTemaVendas.children.assistencias.titulo,
    corIcone: menusTemaVendas.children.assistencias.corIcone,
    children: [
      {
        codificacao: ECodificacao.TemaVendas,
        id: menusTemaVendas.children.assistencias.children.visaoGeral.id,
        nameRoute: cTEMA_VENDAS_ROUTES.Assistencias.VisaoGeral.name,
        icone: menusTemaVendas.children.assistencias.children.visaoGeral.icone,
        titulo: menusTemaVendas.children.assistencias.children.visaoGeral.titulo,
        corIcone: menusTemaVendas.children.assistencias.children.visaoGeral.corIcone,
      },

      {
        codificacao: ECodificacao.TemaVendas,
        id: menusTemaVendas.children.assistencias.children.comparativoVendasxAssistencias.id,
        nameRoute: cTEMA_VENDAS_ROUTES.Assistencias.ComparativoVendasxAssistencias.name,
        icone: menusTemaVendas.children.assistencias.children.comparativoVendasxAssistencias.icone,
        titulo: menusTemaVendas.children.assistencias.children.comparativoVendasxAssistencias.titulo,
        corIcone: menusTemaVendas.children.assistencias.children.comparativoVendasxAssistencias.corIcone,
      },

      {
        codificacao: ECodificacao.TemaVendas,
        id: menusTemaVendas.children.assistencias.children.analiseGeografica.id,
        nameRoute: cTEMA_VENDAS_ROUTES.Assistencias.AnaliseGeografica.name,
        icone: menusTemaVendas.children.assistencias.children.analiseGeografica.icone,
        titulo: menusTemaVendas.children.assistencias.children.analiseGeografica.titulo,
        corIcone: menusTemaVendas.children.assistencias.children.analiseGeografica.corIcone,
      },

      {
        codificacao: ECodificacao.TemaVendas,
        id: menusTemaVendas.children.assistencias.children.metaVendas.id,
        nameRoute: cTEMA_VENDAS_ROUTES.Assistencias.MetaVendas.name,
        icone: menusTemaVendas.children.assistencias.children.metaVendas.icone,
        titulo: menusTemaVendas.children.assistencias.children.metaVendas.titulo,
        corIcone: menusTemaVendas.children.assistencias.children.metaVendas.corIcone,
        children: [
          {
            codificacao: ECodificacao.TemaVendas,
            nameRoute: cTEMA_VENDAS_ROUTES.Assistencias.MetaVendas.Especifico.MetaPorSupervisor.name,
            id: menusTemaVendas.children.assistencias.children.metaVendas.children.metaEspecificaPorSupervisor.id,
            icone: menusTemaVendas.children.assistencias.children.metaVendas.children.metaEspecificaPorSupervisor.icone,
            titulo:
              menusTemaVendas.children.assistencias.children.metaVendas.children.metaEspecificaPorSupervisor.titulo,
            corIcone:
              menusTemaVendas.children.assistencias.children.metaVendas.children.metaEspecificaPorSupervisor.corIcone,
          },

          {
            codificacao: ECodificacao.TemaVendas,
            nameRoute: cTEMA_VENDAS_ROUTES.Assistencias.MetaVendas.Especifico.MetaPorConsultor.name,
            id: menusTemaVendas.children.assistencias.children.metaVendas.children.metaEspecificaPorConsultor.id,
            icone: menusTemaVendas.children.assistencias.children.metaVendas.children.metaEspecificaPorConsultor.icone,
            titulo:
              menusTemaVendas.children.assistencias.children.metaVendas.children.metaEspecificaPorConsultor.titulo,
            corIcone:
              menusTemaVendas.children.assistencias.children.metaVendas.children.metaEspecificaPorConsultor.corIcone,
          },

          {
            codificacao: ECodificacao.TemaVendas,
            nameRoute: cTEMA_VENDAS_ROUTES.Assistencias.MetaVendas.Geral.MetaPorSupervisor.name,
            id: menusTemaVendas.children.assistencias.children.metaVendas.children.metaGeralPorSupervisor.id,
            icone: menusTemaVendas.children.assistencias.children.metaVendas.children.metaGeralPorSupervisor.icone,
            titulo: menusTemaVendas.children.assistencias.children.metaVendas.children.metaGeralPorSupervisor.titulo,
            corIcone:
              menusTemaVendas.children.assistencias.children.metaVendas.children.metaGeralPorSupervisor.corIcone,
          },

          {
            codificacao: ECodificacao.TemaVendas,
            nameRoute: cTEMA_VENDAS_ROUTES.Assistencias.MetaVendas.Geral.MetaPorConsultor.name,
            id: menusTemaVendas.children.assistencias.children.metaVendas.children.metaGeralPorConsultor.id,
            icone: menusTemaVendas.children.assistencias.children.metaVendas.children.metaGeralPorConsultor.icone,
            titulo: menusTemaVendas.children.assistencias.children.metaVendas.children.metaGeralPorConsultor.titulo,
            corIcone: menusTemaVendas.children.assistencias.children.metaVendas.children.metaGeralPorConsultor.corIcone,
          },
        ],
      },
    ],
  },

  {
    codificacao: ECodificacao.TemaVendas,
    id: menusTemaVendas.children.personalizado.id,
    icone: menusTemaVendas.children.personalizado.icone,
    titulo: menusTemaVendas.children.personalizado.titulo,
    corIcone: menusTemaVendas.children.personalizado.corIcone,
    nameRoute: cTEMA_VENDAS_ROUTES.Personalizado.Gerenciador.name,
  },
] as const;

export default cMENUS_TEMA_VENDAS;
